import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';
import { toPriceInEuros } from '@/helpers/prices-helper';
import { Box, Typography, useTheme } from '@mui/material';

const InfoItem = ({ label, value, theme }) => (
    <Box
        sx={{
            borderRadius: 0.5, // Bordes redondeados
            padding: '4px',
            textAlign: 'center',
            backgroundColor: theme.palette.background.default,
            border: `1px solid`,
            borderColor: 'border.main',
            boxShadow: theme.boxShadows.main,
        }}
    >
        <Typography fontSize={12} color="textSecondary" variant="h3">
            {label}
        </Typography>
        <Typography sx={{ fontSize: 12 }}>{toPriceInEuros(value)}</Typography>
    </Box>
);

const ValorMercadoFantasyLaLiga = ({ player, slug }) => {
    const theme = useTheme();
    const valorDeMercado = player?.fi?.mv;
    const subidaDeMercado = player?.fi?.su;
    const pujaIdeal = player?.pu?.pi;
    const pujaMaxima = player?.pu?.pm;
    const ofertaMaxima = (valorDeMercado * 1.1).toFixed(0);
    const ofertaMinima = (valorDeMercado * 0.9).toFixed(0);

    return (
        <CustomSectionWrapper color="accent" title="Valor de mercado de La Liga Fantasy">
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(6, 1fr)' }, // 2 columnas en mobile, 4 en desktop
                    gap: 1,
                    backgroundColor: theme.palette.background.default,
                    borderRadius: 2,
                    padding: '10px',
                }}
            >
                <InfoItem theme={theme} label="Precio" value={valorDeMercado} />
                <InfoItem theme={theme} label="Subida" value={subidaDeMercado} />
                <InfoItem theme={theme} label="Oferta máx." value={ofertaMaxima} />
                <InfoItem theme={theme} label="Oferta mín." value={ofertaMinima} />
                <InfoItem theme={theme} label="Puja ideal" value={pujaIdeal} />
                <InfoItem theme={theme} label="Puja máxima" value={pujaMaxima} />
            </Box>
        </CustomSectionWrapper>
    );
};

export default ValorMercadoFantasyLaLiga;
